import type { ComponentProps } from "react";
import { cn } from "../cn";

/** A key or shortcut shown to the user (tooltips, palette, empty states); hidden on touch screens (ADR-050). */
export function Kbd({ className, ...props }: ComponentProps<"kbd">) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-border bg-muted px-1 font-sans text-[0.6875rem] font-medium text-muted-foreground pointer-coarse:hidden!",
        className,
      )}
      {...props}
    />
  );
}
